module.exports = "/packs/media/images/icons/timeismoney-9aa746f601089f2ba5cb293ddee4793f.png";